import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import type { NavItem } from './BottomNav';
import styles from './NavRail.module.css';

interface NavRailProps {
  /** Navigation items to render. */
  items: NavItem[];
}

/**
 * Navigation rail for medium and expanded screen sizes.
 * Fixed on the inline-start side with icon + small label per item.
 */
export function NavRail({ items }: NavRailProps) {
  return (
    <nav className={styles.navRail} aria-label="Main navigation">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) =>
            cn(styles.navItem, isActive && styles.active)
          }
        >
          <span className={styles.iconWrap} aria-hidden="true">
            {item.icon}
          </span>
          <span className={styles.label}>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
